import { useState, ReactNode } from 'react';
import S from './TooltipStyles';

type Props = {
  content: string;
  children: ReactNode;
};

function Tooltip({ content, children }: Props): JSX.Element {
  const [visible, setVisible] = useState(false);

  return (
    <S.ItemWrapper
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && <S.TooltipBubble>{content}</S.TooltipBubble>}
    </S.ItemWrapper>
  );
}

export default Tooltip;
